import { styled } from "styled-components";

export const ProductName = styled.div`
  width: 120px;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;

  overflow: hidden;
  text-overflow: ellipsis;

  //text-align: left;
`;
